import { Stack } from '@mui/material';
import { useFragment } from '../../../hooks/useFragment';
import { ForceDownloadMediaBtn } from './ForceDownloadMediaBtn';

export function DownloadBtns() {
  const { fragment } = useFragment();
  const audioUrl = fragment.assets.audio?.url;
  const videoUrl = fragment.assets.video?.url;

  return (
    <Stack direction="row" spacing={2}>
      {fragment.mediaType === 'VIDEO' && videoUrl ? (
        <ForceDownloadMediaBtn mediaUrl={videoUrl} mediaType="VIDEO" />
      ) : null}
      {audioUrl ? <ForceDownloadMediaBtn mediaUrl={audioUrl} mediaType="AUDIO" /> : null}
    </Stack>
  );
}
